<template>
    <SearchResultsHeader
        v-if="filteredAndPaginatedSearchResults.length > 0 && !loading"
    />

    <div class="col-span-12 w-full">
        <EmptyResultsFiltered />
        <EmptyResultsSearch />

        <div class="grid gap-4">
            <PropertyCard
                v-for="(property, pIndex) in filteredAndPaginatedSearchResults"
                :property="property"
                :index="pIndex"
                :key="'property-' + pIndex"
            />
        </div>
    </div>
    <div
        class="col-span-12 flex pt-8"
        v-if="filteredAndPaginatedSearchResults.length > 0"
    >
        <Pagination
            :current-page="currentPage"
            :total-pages="totalPages"
            :per-page="perPage"
            :total-results="totalResults"
            :max-visible-buttons="9"
            @page-changed="handlePageChange"
        />
    </div>
</template>

<script>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useHotelsStore } from '@/store/hotels';
import PropertyCard from '@/components/hotels/search/property-card/property-card.vue';
import Pagination from '@/components/ui/pagination/pagination.vue';
import SearchResultsHeader from '@/components/hotels/search/search-results-header/search-results-header.vue';
import EmptyResultsFiltered from '@/components/hotels/search/empty-results/filtered.vue';
import EmptyResultsSearch from '@/components/hotels/search/empty-results/search.vue';

export default {
    components: {
        PropertyCard,
        Pagination,
        SearchResultsHeader,
        EmptyResultsFiltered,
        EmptyResultsSearch,
    },
    emits: ['page-changed'],
    setup(_, { emit }) {
        const hotelsStore = useHotelsStore();
        const {
            filteredAndPaginatedSearchResults,
            filteredSearchResults,
            searchCompleted,
            loading,
            currentPage,
            perPage,
            totalPages,
        } = storeToRefs(hotelsStore);

        const totalResults = computed(() => filteredSearchResults.value.length);

        const handlePageChange = (page) => {
            hotelsStore.setCurrentPage(page);
            emit('page-changed'); //handler scrolls to top
        };

        return {
            searchCompleted,
            filteredAndPaginatedSearchResults,
            handlePageChange,
            loading,
            currentPage,
            totalPages,
            perPage,
            totalResults,
        };
    },
};
</script>
